export var BEAVER_LOG_LEVEL = /* @__PURE__ */ ((BEAVER_LOG_LEVEL2) => {
  BEAVER_LOG_LEVEL2["DEBUG"] = "debug";
  BEAVER_LOG_LEVEL2["INFO"] = "info";
  BEAVER_LOG_LEVEL2["WARN"] = "warn";
  BEAVER_LOG_LEVEL2["ERROR"] = "error";
  return BEAVER_LOG_LEVEL2;
})(BEAVER_LOG_LEVEL || {});
